import {computed} from "vue";

export const JobStatus = {
    //status to be shown when no job run ever existed
    NONE: 'None',
    //status to be shown when the user press the button but the api call has not been completed
    REQUESTED: 'Requested',
    //real statuses
    PENDING: 'Pending',
    FAILED: 'Failed',
    RUNNING: 'Running',
    SCHEDULED: 'Scheduled',
    SUCCESS: 'Success',
    CANCELLING: 'Cancelling',
    CANCELLED: 'Cancelled'
}

export const getMappedStatus = (status) => {
    if ([
        JobStatus.REQUESTED,
        JobStatus.PENDING,
        JobStatus.SCHEDULED
    ].includes(status)) {
        return JobStatus.RUNNING
    }
    return status
}

export const getStatusIcon = (mappedStatus) => {
    switch (mappedStatus) {
        case JobStatus.SUCCESS:
            return 'pi pi-check-circle'
        case JobStatus.FAILED:
            return 'pi pi-bolt'
        case JobStatus.NONE:
            return 'pi pi-minus'
        case JobStatus.CANCELLED:
            return 'pi pi-times'
    }
}

export const getStatusSeverity = mappedStatus => {
    switch (mappedStatus) {
        case JobStatus.SUCCESS:
            return 'success'
        case JobStatus.FAILED:
            return 'danger'
        case JobStatus.NONE:
            return 'info'
        case JobStatus.CANCELLED:
            return 'warning'
    }
}


